import { FC, useEffect, useState } from "react";
import { StoreInfoCard } from "../storeInfocards/storeInfocards";
import "./index.css";
import { PluginconfigType } from "../../contexts/AppConfigContext";
import { usePluginspace } from "../../hooks/usePluginspace";
import Swal from "sweetalert2";

type StoreInfoContact = {
  config: any;
  plugins: PluginconfigType[];
  redeSocial: RedeSocial[];
};

type RedeSocial = {
  id: number;
  name: string;
  url: string;
  type: string;
};

const StoreInfoContact: FC<StoreInfoContact> = ({
  config,
  plugins,
  redeSocial,
}) => {
  const [hasPhone, setHasPhone] = useState(false);
  const [hasWhats, setHasWhats] = useState(false);
  const { pluginspace } = usePluginspace();

  function whatAppLink() {
    let sellerPhone = redeSocial.find((config) => {
      return config.type === "WHATSAPP";
    });

    if (sellerPhone) {
      setHasWhats(true);
      window.open(
        `https://wa.me/${sellerPhone.url.replace(
          /\D/g,
          ""
        )}?text=Gostaria%20de%20algumas%20informações`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Essa loja não possui um whatsApp de contato",
      });
    }
  }

  function callPhone() {
    if (pluginspace && pluginspace.phoneContact) {
      window.location.href = `tel:${pluginspace.phoneContact}`;
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Essa loja não possui um telefone de contato",
      });
    }
  }

  const sendEmail = () => {
    if (pluginspace && pluginspace.emailContact) {
      const mailtoLink = `mailto:${pluginspace.emailContact}`;
      window.location.href = mailtoLink;
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Essa loja não possui um email de contato",
      });
    }
  };

  function hasPhones() {
    let sellerPhone = plugins.find((config) => {
      return (
        (config.plugintemplateId === 31 || config.plugintemplateId === 19) &&
        config.content.able === "1"
      );
    });

    if (sellerPhone) {
      setHasPhone(true);
      setHasWhats(true);
    }
  }

  useEffect(() => {
    hasPhones();
  }, []);

  return (
    <div className="info-loja-contact">
      {pluginspace && pluginspace.type !== "food" && (
        <>
          <div className="loja-img">
            <img src={config?.img} alt="" className="" />
          </div>
          <h3 className="loja-name">{config?.name}</h3>
        </>
      )}
      <div
        className="loja-info"
        dangerouslySetInnerHTML={{ __html: config?.info ? config?.info : "" }}
      />
      <div className="loja-buttons">
        <StoreInfoCard
          backGroundColor={
            config?.webappcolor.webappbutton
              ? config?.webappcolor.webappbutton
              : "#86726E"
          }
          fontColor={
            config?.webappcolor.fontbutton
              ? config?.webappcolor.fontbutton
              : "#FFFFFF"
          }
          type={"whatsApp"}
          action={() => whatAppLink()}
          isAble={hasWhats}
        />

        <StoreInfoCard
          backGroundColor={
            config?.webappcolor.webappbutton
              ? config?.webappcolor.webappbutton
              : "#86726E"
          }
          fontColor={
            config?.webappcolor.fontbutton
              ? config?.webappcolor.fontbutton
              : "#FFFFFF"
          }
          type={"telefone"}
          action={() => callPhone()}
          isAble={hasPhone}
        />

        <StoreInfoCard
          backGroundColor={
            config?.webappcolor.webappbutton
              ? config?.webappcolor.webappbutton
              : "#86726E"
          }
          fontColor={
            config?.webappcolor.fontbutton
              ? config?.webappcolor.fontbutton
              : "#FFFFFF"
          }
          type={"email"}
          action={() => sendEmail()}
        />
      </div>
    </div>
  );
};

export { StoreInfoContact };
